import React from 'react'

export const CRM_Solicitud_Credito = () => {
  return (
    <div>CRM_Solicitud_Credito</div>
  )
}
